import React from "react";
import "./Partner.scss";
import { Image } from "react-bootstrap";

export default function Partner() {
  const ListEcosystem = [
    {
      link: "https://nibiru.fi",
      icon: require("assets/images/partner/nibiru.png"),
    },
    {
      link: "https://gravity.xyz",
      icon: require("assets/images/partner/gravity.png"),
    },
    {
      link: "https://polkadot.com",
      icon: require("assets/images/partner/polkadot.png"),
    },
    {
      link: "https://cosmos.network",
      icon: require("assets/images/partner/cosmos.png"),
    },
    {
      link: "https://qu.ai",
      icon: require("assets/images/partner/quai.png"),
    },
    {
      link: "https://www.starknet.io",
      icon: require("assets/images/partner/starknet.png"),
    },
    {
      link: "https://www.tanssi.network",
      icon: require("assets/images/partner/tanssi.png"),
    },
  ];

  return (
    <div id="partner" className="home-container">
      <p
        style={{
          fontWeight: "600",
          fontSize: "32px",
          color: "#2A7AD7",
          textAlign: "center",
          paddingTop: "104px",
        }}
      >
        Trusted Partner
      </p>

      <div
        className="partner"
        style={{
          height: "40px",
          marginTop: "46px",
          position: "relative",
          mask: "linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 48.8%, rgba(255, 255, 255, 0) 97.6%)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "48px",
            position: "absolute",
            inset: 0,

            animation: "animationSpeed 14s linear infinite",
          }}
        >
          {React.Children.toArray(
            [...Array(2)].map(() =>
              React.Children.toArray(
                ListEcosystem.map((meta) => (
                  <Image
                    src={meta.icon}
                    alt={meta.icon}
                    cursor="pointer"
                    onClick={() => window.open(meta.link, "_blank")}
                  />
                ))
              )
            )
          )}
        </div>
      </div>
    </div>
  );
}
